import React, { useContext } from "react";
import "./components.css";

import Countdown, { zeroPad } from "react-countdown";
import { AppContext } from "../context/AppContext";
import { useNavigate, useParams } from "react-router-dom";
import { decryptData, encryptData, getFromStorage, removeFromStorage, setToStorage } from "../assets";
import { makePostAPICall } from "../helpers/ApiHelpers";

const TimerPerQuestion = ({ setLoading, aref, setCurrentQuestion, currentQuestion }) => {
	const { exam, user, setExam } = useContext(AppContext);
	let navigate = useNavigate();
	let params = useParams();

	const markExamPerQuestion = (answers, examQuestions) => {
		setLoading(true);
		let questions = [];
		for (const property in answers) {
			const answer = answers[property];
			const questionType = answer?.startsWith("option") ? "objective" : "theory";
			const finalAnswer = answer?.startsWith("option") ? answers[property].substr(6, 1) : answer;

			questions.push({
				id: property,
				type: questionType,
				answer: finalAnswer,
			});
		}

		let duration = decryptData(getFromStorage("timeLeft"));
let tabSwitchCount = decryptData(getFromStorage("tsc")) || 0;
		makePostAPICall(
			"exams.php",
			{
				action: "submit_exam",
				user_id: user.id,
				exam_id: exam?.id,
				marks: exam?.marks_per_answer,
				duration: duration ?? 0,
					submission_type: "timeout",
				tab_switch_count: tabSwitchCount,
				questions,
			},
			(response) => {
				setToStorage("result", JSON.stringify(response.data));
				navigate(`/exam/${params.id}/end`);
				setExam((prevState) => {
					const { questions, ...others } = prevState;
					return { ...others, examStatus: "ended" };
				});
			},
			() => markExamPerQuestion(answers, examQuestions)
		);
	};

	const timeLeft = decryptData(getFromStorage("timeLeft"));

	return (
		<div className="timer-container" ref={aref}>
			<div className="timer-title">Time remaining</div>
			<div className="timer-text">
				<Countdown
					date={Date.now() + (timeLeft || parseFloat(exam?.duration) * 60 * 1000)}
					renderer={({ hours, minutes, seconds }) => (
						<span>
							{zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}
						</span>
					)}
					onTick={({ total }) => {
						setToStorage("timeLeft", encryptData(total));
					}}
					onComplete={() => {
						removeFromStorage("timeLeft");
						const numQuestions = exam?.questions?.length;

						if (currentQuestion === numQuestions) {
							const answers = decryptData(getFromStorage("answers"));
							const examQuestions = exam?.questions;
							markExamPerQuestion(answers, examQuestions);
							return;
						}
						setCurrentQuestion((prevState) => prevState + 1);
					}}
				/>
			</div>
		</div>
	);
};

export default TimerPerQuestion;
